import React from 'react';
import { func, string } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';

const DiscardButton = ({ type, onClick }) => (
  <Button type={type} onClick={onClick} sx={{ fontSize: '15px', color: 'secondary.main' }}>
    {I18n.t('AcknowledgementCreate.Discard')}
  </Button>
);
DiscardButton.propTypes = {
  type: string.isRequired,
  onClick: func.isRequired,
};

export default DiscardButton;
